import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ProfileType } from '@rma/generic/domain/types';
import { appendCamelCaseJsonHeader } from '@rma/generic/ng/http';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';
import { CurrentProfileContext } from './domain/profile-context.models';

@Injectable({
  providedIn: 'root',
})
export class ProfileContextApiService {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public getProfileContextDetails(profileType: ProfileType, profileCode: string): Observable<CurrentProfileContext> {
    const url = this.rmaApiUrl(`${profileType}/${profileCode}/ContextDetails`);
    return this.httpClient.get<CurrentProfileContext>(url, appendCamelCaseJsonHeader());
  }
}
